import { writable } from 'svelte/store';

export const supplierList =  writable([]);
export const supplierProductList =  writable([]);
export const supplierLinkList =  writable([]); // Used in Productr Managment

export const suppliersList =  writable([]); // temporary data for Delivery Schedule and Amendments 